/**
 * @generated SignedSource<<d0d97a268f36e5b06bacc8737d58fa3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateBenefitsContentfulRelayFragment$data = {
  readonly benefitsTitle: string | null | undefined;
  readonly templateBenefitContainerCollection: {
    readonly items: ReadonlyArray<{
      readonly shortDescription: {
        readonly json: any;
      } | null | undefined;
      readonly templateBenefitNameExternal: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "templateBenefitsContentfulRelayFragment";
};
export type templateBenefitsContentfulRelayFragment$key = {
  readonly " $data"?: templateBenefitsContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateBenefitsContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateBenefitsContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "benefitsTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TemplateBenefitContainerTemplateBenefitContainerCollection",
      "kind": "LinkedField",
      "name": "templateBenefitContainerCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateBenefit",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateBenefitNameExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TemplateBenefitShortDescription",
              "kind": "LinkedField",
              "name": "shortDescription",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "json",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TemplateBenefitContainer",
  "abstractKey": null
};

(node as any).hash = "0aed3146fda17479886541e7fa74c49c";

export default node;
